(() => {
  'use strict';

  if (window.__antlitzwerkStarDividerDirectBound) return;
  window.__antlitzwerkStarDividerDirectBound = true;

  const ACTIVE_CLASS = 'aw-star-divider-interacting';
  const SELECTOR = '[data-aw-star-divider]';
  const root = document.documentElement;
  const coarsePointer = window.matchMedia('(pointer: coarse)');

  let touchActive = false;
  let pointerActive = false;
  let releaseTimer = 0;
  let desktopPulseTimer = 0;

  const hasDivider = () => Boolean(document.querySelector(SELECTOR));

  const clearReleaseTimer = () => {
    window.clearTimeout(releaseTimer);
    releaseTimer = 0;
  };

  const clearDesktopPulseTimer = () => {
    window.clearTimeout(desktopPulseTimer);
    desktopPulseTimer = 0;
  };

  const activate = () => {
    if (!hasDivider()) return;
    clearReleaseTimer();
    root.classList.add(ACTIVE_CLASS);
  };

  const deactivate = (delay = 190) => {
    clearReleaseTimer();
    releaseTimer = window.setTimeout(() => {
      if (!touchActive && !pointerActive) root.classList.remove(ACTIVE_CLASS);
    }, delay);
  };

  const pulseDesktop = (duration = 260) => {
    if (coarsePointer.matches || !hasDivider()) return;
    activate();
    clearDesktopPulseTimer();
    desktopPulseTimer = window.setTimeout(() => {
      if (!pointerActive) deactivate(85);
    }, duration);
  };

  document.addEventListener('touchstart', (event) => {
    if (!event.touches || event.touches.length === 0) return;
    touchActive = true;
    activate();
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', () => {
    touchActive = true;
    activate();
  }, { passive: true, capture: true });

  document.addEventListener('touchend', (event) => {
    touchActive = Boolean(event.touches && event.touches.length);
    if (!touchActive) deactivate(190);
  }, { passive: true, capture: true });

  document.addEventListener('touchcancel', () => {
    touchActive = false;
    deactivate(135);
  }, { passive: true, capture: true });

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'touch') return;
    pointerActive = true;
    activate();
  }, { passive: true, capture: true });

  document.addEventListener('pointerup', (event) => {
    if (event.pointerType === 'touch') return;
    pointerActive = false;
    deactivate(115);
  }, { passive: true, capture: true });

  document.addEventListener('pointercancel', (event) => {
    if (event.pointerType === 'touch') return;
    pointerActive = false;
    deactivate(135);
  }, { passive: true, capture: true });

  document.addEventListener('wheel', () => pulseDesktop(280), { passive: true, capture: true });


  document.addEventListener('keydown', (event) => {
    const scrollKeys = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '];
    if (scrollKeys.includes(event.key)) pulseDesktop(340);
  }, { capture: true });

  const reset = () => {
    touchActive = false;
    pointerActive = false;
    clearReleaseTimer();
    clearDesktopPulseTimer();
    root.classList.remove(ACTIVE_CLASS);
  };

  window.addEventListener('blur', reset);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) reset();
  });
})();
